import numeral from "numeral";

const DECIMAL_SEP = ".";

export const pureNumberFilter = (num: number | string | null, format = "0,0.[000]", na: string = "N/A"): string => {
    if (num === null) {
        return na;
    }
    return numeral(num).format(format);
};

/**
 * format a number to a decimal point
 * test for this function are in numberFilter.spec.ts and are taken from angular.js
 */
export const numberFilter =
    () =>
    (num: number | string | undefined | null, decimal?: number): string => {
        if (num == null || isNaN(Number(num)) || typeof num === "object") {
            return "";
        }

        const isFloat = num.toString().includes(DECIMAL_SEP);
        if (isFloat || decimal) {
            return pureNumberFilter(num, `0,0.${"0".repeat(decimal ?? 3)}`);
        }

        const isInfinity = num === Infinity;
        const isNegativeInfinity = num === -Infinity;
        if (isInfinity) {
            return "∞";
        } else if (isNegativeInfinity) {
            return "-∞";
        }

        return pureNumberFilter(num, "0,0");
    };
